/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a bar chart from pasted data — single or grouped bars, no sign-up.`)
};

const es_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un gráfico de barras a partir de datos pegados — barras simples o agrupadas, sin registro.`)
};

const de_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Balkendiagramm aus eingefügten Daten — einzelne oder gruppierte Balken, keine Anmeldung erforderlich.`)
};

const nl_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een staafdiagram van geplakte data — enkele of gegroepeerde staven, geen registratie nodig.`)
};

const fr_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un graphique à barres à partir de données collées — barres simples ou groupées, sans inscription.`)
};

const it_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico a barre dai dati incollati — barre singole o raggruppate, senza registrazione.`)
};

const pt_br2_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de barras a partir de dados colados — barras simples ou agrupadas, sem cadastro.`)
};

const pt_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de barras a partir de dados colados — barras simples ou agrupadas, sem registo.`)
};

const ja_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貼り付けたデータから棒グラフを作成します — 単純な棒またはグループ化された棒、登録不要。`)
};

const zh_bar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据粘贴的数据创建柱状图——单系列或分组柱状图，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_tool_description", locale)
	if (locale === "en") return en_bar_tool_description(inputs)
	if (locale === "es") return es_bar_tool_description(inputs)
	if (locale === "de") return de_bar_tool_description(inputs)
	if (locale === "nl") return nl_bar_tool_description(inputs)
	if (locale === "fr") return fr_bar_tool_description(inputs)
	if (locale === "it") return it_bar_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_bar_tool_description(inputs)
	if (locale === "pt") return pt_bar_tool_description(inputs)
	if (locale === "ja") return ja_bar_tool_description(inputs)
	return zh_bar_tool_description(inputs)
};